import React, { useState } from 'react';
// --- PDF Viewer component ---
function PDFViewer({ pdfUrl, width, height, x, y, onSelect, isSelected, tool }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [scale, setScale] = useState(1.0);
  
  const handleClick = (e) => {
    if (onSelect) {
      onSelect();
    }
  };

  const handleMouseDown = (e) => {
    e.stopPropagation();
    if (onSelect) {
      onSelect();
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const zoomIn = () => {
    setScale(prev => Math.min(prev + 0.2, 3.0));
  };

  const zoomOut = () => {
    setScale(prev => Math.max(prev - 0.2, 0.5));
  };

  const isDrawingTool = tool === 'pen' || tool === 'highlighter' || tool === 'eraser';

  return (
    <foreignObject x={x} y={y} width={width} height={height}>
      {/* Explicit px, not '100%' — Safari doesn't reliably resolve
          percentage sizing against a <foreignObject>'s own coordinate box
          under a transformed/scaled ancestor (the whiteboard pans/zooms
          via the SVG's viewBox). */}
      <div
        style={{
          width: `${width}px`,
          height: `${height}px`,
          position: 'relative',
          cursor: isDrawingTool ? 'crosshair' : 'pointer',
          background: '#f5f5f5',
          borderRadius: '8px',
          overflow: 'hidden',
          pointerEvents: isDrawingTool ? 'none' : 'auto'
        }}
        onClick={handleClick}
        onMouseDown={handleMouseDown}
      >
        {/* PDF Controls */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          background: 'rgba(0,0,0,0.7)',
          color: 'white',
          padding: '8px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          zIndex: 20,
          fontSize: '12px'
        }}>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <button 
              onClick={(e) => { e.stopPropagation(); prevPage(); }}
              disabled={currentPage <= 1}
              style={{
                background: currentPage <= 1 ? '#666' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '4px 8px',
                cursor: currentPage <= 1 ? 'not-allowed' : 'pointer',
                fontSize: '10px'
              }}
            >
              ←
            </button>
            <span>{currentPage} / {totalPages}</span>
            <button 
              onClick={(e) => { e.stopPropagation(); nextPage(); }}
              disabled={currentPage >= totalPages}
              style={{
                background: currentPage >= totalPages ? '#666' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '4px 8px',
                cursor: currentPage >= totalPages ? 'not-allowed' : 'pointer',
                fontSize: '10px'
              }}
            >
              →
            </button>
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <button 
              onClick={(e) => { e.stopPropagation(); zoomOut(); }}
              style={{
                background: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '4px 8px',
                cursor: 'pointer',
                fontSize: '10px'
              }}
            >
              -
            </button>
            <span>{Math.round(scale * 100)}%</span>
            <button 
              onClick={(e) => { e.stopPropagation(); zoomIn(); }}
              style={{
                background: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '4px 8px',
                cursor: 'pointer',
                fontSize: '10px'
              }}
            >
              +
            </button>
          </div>
        </div>

        {/* PDF Content */}
        <div style={{
          width: '100%',
          height: '100%',
          paddingTop: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'auto'
        }}>
          <iframe
            title="PDF Viewer"
            src={`${pdfUrl}#page=${currentPage}&zoom=${scale * 100}`}
            width="100%"
            height="100%"
            style={{
              border: 'none',
              transform: `scale(${scale})`,
              transformOrigin: 'center center'
            }}
            onMouseDown={(e) => e.stopPropagation()}
            onLoad={(e) => {
              // Try to get total pages from PDF
              try {
                const iframe = e.target;
                iframe.contentWindow.addEventListener('message', (event) => {
                  if (event.data && event.data.type === 'pdf-pages') {
                    setTotalPages(event.data.pages);
                  }
                });
              } catch (error) {
        
              }
            }}
          />
        </div>
      </div>
    </foreignObject>
  );
}

// --- YouTube iframe component ---

export default PDFViewer;
